<template>	 
    <el-header class="top_bar flex">
        <div class="top_bar_left">
            <div class="toggle-button" @click="toggleCollapse"><i class="iconfont icon_drag"></i></div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="top_bar_right flex">
            <div class="menu_toggle" @click="changmenuDrawer">
                <i class="iconfont icon_drag"></i>
            </div>
            <div class="flex">
                <el-dropdown>
                    <div class="el-dropdown-link">
                        <div class="avatar flex">
                            <!-- <span class="avatar_img"> -->
                                <!-- <img src="../../assets/images/avatar.jpg" alt=""> -->
                            <!-- </span> -->
                            <span class="avatar_name">
                                {{userName}}
                            </span>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item ><span @click="logout">退出登录</span></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </el-header>
</template>

<script>
export default {
    name: "app",
    data(){
        return{
            
        }
    },
    methods:{
        
        toggleCollapse() {
            this.$Bus.$emit('collapseChange');
        },
        changmenuDrawer(){
            this.$Bus.$emit('changmenuDrawer');
        },
        logout(){
            window.localStorage.removeItem('token');
            window.location.href='login';
        }
    },
    props:['userName']
}
</script>